import React from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '../app/hooks';
import { useAppDispatch } from '../app/store';
import { getWeekdays, DATE_FORMAT, UI_MONTH_FORMAT, fillWeeksForGrid, getMonthsInRange } from '../helpers/date-helpers';
import { setCurrentDate, goToNextMonth, goToPreviousMonth, resetCurrentDate } from '../features/calendar/calendar-slice';

export type MonthDropdownProps = {
    hideLabel: boolean;
    filterCloseCallback?: () => void;
}

export const MonthDropdown = (props: MonthDropdownProps) => {
    let { hideLabel, filterCloseCallback } = props;
    const dispatch = useAppDispatch();
    const today = useAppSelector(state => state.calendar.todaysDate);
    const { lastDate, monthDropdownDescriptionText } = useAppSelector(state => state.settings);
    const allMonths = getMonthsInRange(today, lastDate);
    const currentDate = useAppSelector(state => state.calendar.currentDate);
    const eventsAreLoading = useAppSelector(state => state.calendar.eventsAreLoading);

    const monthChanged = (e: React.FormEvent<HTMLSelectElement>) => {
        dispatch(setCurrentDate({ newDate: dayjs((e.target as HTMLSelectElement).value).startOf('month').format(DATE_FORMAT), shouldChangeRange: true }));
        if (filterCloseCallback) {
            filterCloseCallback();
        }
    }

    return (
        <>
            <label htmlFor="MonthDropdown" className={hideLabel ? `visually-hidden` : ''}>{monthDropdownDescriptionText}</label>
            <select id="MonthDropdown" value={dayjs(currentDate).startOf('month').format(DATE_FORMAT)} onChange={(e) => monthChanged(e)} disabled={eventsAreLoading} className="ace-cal-month-dropdown">
                {
                    allMonths.map((month, key) => (
                        <option key={key} value={month.month}>{dayjs(month.month).format(UI_MONTH_FORMAT)}</option>
                    ))
                }
            </select>
        </>
    )
}